import $ from 'jquery';

const noop = () => {};

const toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (!value) {
        return [];
    }

    return [value];
};

export const createModalController = (config = {}) => {
    const {
        popupSelector,
        modalInnerSelector,
        openTriggerSelector,
        closeTriggerSelector = [],
        readyClass = 'ready',
        openClass = 'open',
        closeOnOverlayClick = true,
        closeOnEscape = true,
        lockScroll = false,
        onOpen = noop,
        onClose = noop,
    } = config;

    if (!popupSelector) {
        return null;
    }

    const popup = $(popupSelector);
    if (!popup.length) {
        return null;
    }

    const innerSelector = modalInnerSelector || `${popupSelector}__inner`;
    const closeSelectors = toArray(closeTriggerSelector);

    const toggleScrollLock = (isOpen) => {
        if (!lockScroll) {
            return;
        }

        document.documentElement.style.overflowY = isOpen ? 'hidden' : 'auto';
    };

    const showPopup = (event) => {
        if (event) {
            event.preventDefault();
        }

        popup.addClass(openClass);
        toggleScrollLock(true);
        onOpen(popup);
    };

    const hidePopup = (event) => {
        if (event) {
            event.preventDefault();
        }

        popup.removeClass(openClass);
        toggleScrollLock(false);
        onClose(popup);
    };

    if (document.readyState === 'complete') {
        popup.addClass(readyClass);
    } else {
        $(window).on('load', () => {
            popup.addClass(readyClass);
        });
    }

    if (openTriggerSelector) {
        $(document).on('click', openTriggerSelector, showPopup);
    }

    closeSelectors.forEach((selector) => {
        $(document).on('click', selector, hidePopup);
    });

    if (closeOnOverlayClick) {
        popup.on('click', (event) => {
            const clickedInsideInner = $(event.target).closest(innerSelector).length > 0;
            if (!clickedInsideInner) {
                hidePopup(event);
            }
        });
    }

    if (closeOnEscape) {
        $(document).on('keydown', (event) => {
            if (event.key === 'Escape' && popup.hasClass(openClass)) {
                hidePopup();
            }
        });
    }

    return {
        showPopup,
        hidePopup,
        popup,
    };
};
